import { CheckboxDropdown, Table } from '@exxonmobil/react-unity';
import React from 'react';
import styled from 'styled-components';
import { Column } from '../types/Column';

interface Props {
  columns: Column[];
  columnValues: Record<string, (string | number)[]>;
  onChangeFilter: Function;
}

export const EndpointHead = ({ columns, columnValues, onChangeFilter }: Props) => (
  <StyledTableHead>
    <Table.Head.Row style={{ height: '60px' }}>
      {columns.map((column) => column.checked && EndpointHeadCell(column, columnValues, onChangeFilter))}
    </Table.Head.Row>
  </StyledTableHead>
);

const EndpointHeadCell = (
  column: Column,
  columnValues: Record<string, (string | number)[]>,
  onChangeFilter: Function
) => {
  const { filterDisabled, width, name, hiddenValues } = column;
  if (filterDisabled) {
    return (
      <Table.Head.Cell style={{ minWidth: `${width}px`, verticalAlign: 'middle' }} key={name}>
        {name}
      </Table.Head.Cell>
    );
  }

  return (
    <Table.Head.Cell style={{ minWidth: `${width}px` }} key={name}>
      <CheckboxDropdown label={name} buttonProps={{ size: 'small' }} id="header-dropdown">
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {columnValues[name].map((value) => {
          const checked = !hiddenValues[value];
          return (
            <StyledCheckboxDropdown
              key={value}
              label={value}
              inputProps={{ checked }}
              onChange={() => onChangeFilter(name, value, !checked)}
            />
          );
        })}
      </CheckboxDropdown>
    </Table.Head.Cell>
  );
};

const StyledCheckboxDropdown = styled(CheckboxDropdown.Item)`
  & label {
    font-size: 0.75rem;
  }
`;

const StyledTableHead = styled(Table.Head)`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;

  & .em-c-dropdown-check__panel {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
